import { convertMastersData } from "./Util";

export const mapGrievanceModeMaster = (input: any) => {
    const modeToId: Record<string, number> = {
        'KRPH': 1,
        'Bima Bharosa': 2,
        'INGRAM': 3,
        'CPGRAMS': 4,
        'iAgri/Kshema': 5,
        'Toll Free Number': 6,
        'Physical Post': 7,
        'Customer Walk-in/Self-help Kiosk': 8,
        'Public link': 9,
        'Social Media': 10,
        'QR Code': 11,
        'WhatsApp': 12,
        'SMS': 13,
        'Email': 14,
        'Website': 15,
        'CM Windows/Letters or Emails from the State Govt/CM Office': 16,
        'Insurance Councils': 17,
        'Mails from PMFBY': 18,
        'Sales': 19,
        'To Be Assigned': 20,
        'Sampark': 22,
        'GOI': 23
    };

    const idToMode: Record<number, string> = {};
    for (const mode in modeToId) {
        idToMode[modeToId[mode]] = mode;
    }

    if (typeof input === 'string') {
        return modeToId[input.trim()] || null;
    } else if (typeof input === 'number') {
        return idToMode[input] || null;
    } else {
        return 'N/A';
    }
};

export const mapGrievanceTypeMaster = (input: any) => {
    const typeToId: Record<string, number> = {
        "Proposal Processing": 1,
        'Proposal Related': 7,
        'Cover Note Related': 8,
        'Policy Related': 9,
        'Premium': 10,
        'Coverage': 11,
        'Refund': 12,
        'Product': 13,
        'Claim': 14,
        'Others': 15,
        'To Be Assigned': 16,
        'KRPH': 17,
        'RTI': 18
    };

    const idTotype: Record<number, string> = {};
    for (const type in typeToId) {
        idTotype[typeToId[type]] = type;
    }

    if (typeof input === 'string') {
        return typeToId[input.trim()] || null;
    } else if (typeof input === 'number') {
        return idTotype[input] || null;
    } else {
        return 'N/A';
    }
};

export const mapGrievanceSourceMaster = (input: any) => {
    const sourceToId: Record<string, number> = {
        'Direct': 1,
        'InDirect': 2,
        'To Be Assigned': 3
    };

    const idTosource: Record<number, string> = {};
    for (const source in sourceToId) {
        idTosource[sourceToId[source]] = source;
    }

    if (typeof input === 'string') {
        return sourceToId[input.trim()] || null;
    } else if (typeof input === 'number') {
        return idTosource[input] || null;
    } else {
        return 'N/A';
    }
};

export const mapStatusMaster = (input: any) => {
    const statusToId: Record<string, number> = {
        'New': 1,
        'In Progress': 2,
        'Resolve': 3,
        'Reopen': 4,
        'Close': 5,
    };

    const idTostatus: Record<number, string> = {};
    for (const status in statusToId) {
        idTostatus[statusToId[status]] = status;
    }

    if (typeof input === 'string') {
        return statusToId[input.trim()];
    } else if (typeof input === 'number') {
        return idTostatus[input];
    } else {
        return 'N/A';
    }
};

export const mapLOBMaster = (input: any) => {
    const statusToId: Record<string, number> = {
        'Crop - Retail': 1,
        'Crop(PMFBY)': 2,
        'Fire': 3,
        'Motor': 4,
        'Health': 5,
        'RWBCIS': 6,
        'To be Assigned': 7
    };

    const idTostatus: Record<number, string> = {};
    for (const status in statusToId) {
        idTostatus[statusToId[status]] = status;
    }

    if (typeof input === 'string') {
        return statusToId[input.trim()];
    } else if (typeof input === 'number') {
        return idTostatus[input];
    } else {
        return 'N/A';
    }
};

export const mapRequestTypeMaster = (input: any) => {
    const statusToId: Record<string, number> = {
        'Grievance': 1,
        'Query': 2,
        'Service Request': 3,
        'To Be Assigned': 5
    };

    const idTostatus: Record<number, string> = {};
    for (const status in statusToId) {
        idTostatus[statusToId[status]] = status;
    }

    if (typeof input === 'string') {
        return statusToId[input.trim()];
    } else if (typeof input === 'number') {
        return idTostatus[input];
    } else {
        return 'Grievance';
    }
};

export const mapFDMaster = (input: any) => {
    const statusToId: Record<string, number> = {
        'Fully Accepted': 1,
        'Partially Accepted': 2,
        'Rejected': 3,
    };

    const idTostatus: Record<number, string> = {};
    for (const status in statusToId) {
        idTostatus[statusToId[status]] = status;
    }

    if (typeof input === 'string') {
        return statusToId[input.trim()];
    } else if (typeof input === 'number') {
        return idTostatus[input];
    } else {
        return 'N/A';
    }
};

export const mapMasters = (input: any, data: any) => {
    const valueToId: Record<string, number> = convertMastersData(data);

    const idToValue: Record<number, string> = {};
    for (const value in valueToId) {
        idToValue[valueToId[value]] = value;
    }

    if (typeof input === 'string') {
        return valueToId[input.trim()];
    } else if (typeof input === 'number') {
        return idToValue[input];
    } else {
        return 'N/A';
    }
};